import Vue from 'vue';
import VueFull from 'vuefull';;
import { Component } from 'vue-property-decorator';


@Component
export default class ModuleComponent extends Vue {
    currentcount: string = "Hallo World";

    load() {
    }
}
